import store from "../../Redux/store";
import { setCommissions,countCommissions } from "./Commissions.reducer";

export function saveCommissions(records) {
  store.dispatch(setCommissions(records));
}
export function saveCountCommissions(count) {
  store.dispatch(countCommissions(count));
}